export const AppRoutes = {
  // Home
  home: "/",

  // Company (取引先)
  companyCreate: "/company/create",

  // Information
  information: "/information",
  informationDetail: "/information/:id",

  // Login
  login: "/login",
  logout: "/logout",
  authCallback: "/auth/callback",
  confirmEmail: "/user-setting/confirm-email",

  // User setting
  userSettingDetail: "/user-setting",
  userSettingEdit: "/user-setting/edit",

  // page not found
  pageNotFound: "/page-not-found",
  serverErrorPage: "/server-error",

  // Maintenance
  maintenance: "/maintenance",

  // Organization (組織設定) — one fixed path per tab
  organization: "/organization",
  organizationBusiness: "/organization/business",
  organizationBusinessEdit: "/organization/business/edit",
  organizationProduct: "/organization/product",
  organizationProductNew: "/organization/product/new",
  organizationProductDetail: "/organization/product/:productId",
  organizationProductEdit: "/organization/product/:productId/edit",
  organizationInvoice: "/organization/invoice",
  organizationInvoiceEdit: "/organization/invoice/edit",
  organizationTemplate: "/organization/template",
  organizationMail: "/organization/mail",
  organizationUser: "/organization/user",
  organizationCsv: "/organization/csv",
  organizationProductLink: "/organization/product-link",
};

export const LoginRoutes = [AppRoutes.login, AppRoutes.confirmEmail];

export const ClientRoutes = [AppRoutes.home];

export const OrganizationRoutes = [
  AppRoutes.organization,
  AppRoutes.organizationBusiness,
  AppRoutes.organizationBusinessEdit,
  AppRoutes.organizationProduct,
  AppRoutes.organizationProductNew,
  AppRoutes.organizationProductDetail,
  AppRoutes.organizationProductEdit,
  AppRoutes.organizationInvoice,
  AppRoutes.organizationInvoiceEdit,
  AppRoutes.organizationTemplate,
  AppRoutes.organizationMail,
  AppRoutes.organizationUser,
  AppRoutes.organizationCsv,
  AppRoutes.organizationProductLink,
];
